import { rootApi } from '../rootApi';

export const vehicleItemsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getVehicleItems: builder.query({
            query: (params) => {
                // params: { productGroup, model }
                let queryParams = {};
                if (params?.productGroup) {
                    queryParams.productGroup = params.productGroup;
                } else if (params?.model) {
                    queryParams.model = params.model;
                }
                return {
                    url: `v1/exportedcars/vehicleitems`,
                    method: 'GET',
                    params: queryParams
                };
            },
            transformResponse: (response) => {
                // API yanıtını dönüştür ve doğrula
                if (!response?.data) {
                    return [];
                }
                return response.data.map((item) => ({
                    id: item.id,
                    displayText: item.displayText,
                    recordValue: item.recordValue,
                    productGroup: item.productGroup
                }));
            }
        })
    })
});

export const { useGetVehicleItemsQuery } = vehicleItemsApi;
